import React from 'react';
import './index.css';
import '../../../App.css';

const MenuSuperior = () => {
    return (
        <div className="container-fluid bg-primary px-5 d-none d-lg-block">
            <div className="row gx-0 align-items-center" style={{ height: 45 }}>
                <div className="col-lg-8 text-center text-lg-start mb-lg-0">
                    <div className="d-flex flex-wrap">
                        <a href="#" className="text-light me-4">
                            <i className="fas fa-map-marker-alt text-light me-2"></i>
                            Hospital Unimed
                        </a>
                        <a href="#" className="text-light me-4"><i className="fas fa-phone-alt text-light me-2"></i>(35)
                            3529-2600</a>
                        <a href="#" className="text-light me-0"><i
                            className="fas fa-envelope text-light me-2"></i>Email@unimed.com</a >
                    </div>
                </div>
                <div className="col-lg-4 text-center text-lg-end">
                    <div className="d-flex align-items-center justify-content-end">
                        <a href="#" className="d-flex btn btn-light btn-square border rounded-circle nav-fill me-3 btnSocialMedia"><i
                            className="fab fa-facebook-f"></i></a >
                        <a href="#" className="d-flex btn btn-light btn-square border rounded-circle nav-fill me-3 btnSocialMedia"><i
                            className="fab fa-instagram"></i></a >
                        <a href="#" className="d-flex btn btn-light btn-square border rounded-circle nav-fill me-0 btnSocialMedia"><i
                            className="fab fa-linkedin-in"></i></a >
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MenuSuperior;